export class DatabaseTools {
    static errorIdLoginAnswerQuestions = 328_123_001;
    static errorIdLoginMustSetPassword = 328_123_002;
}
